<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ouF2Ie/tc-custom/buylink_9781439199862_cover.jpg?1718182738271?1730528481005" alt="This image is the cover for the book Quilter's Apprentice, The Elm Creek Quilts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quilter's Apprentice, The Elm Creek Quilts
      </h1>
      <p class="bookDescription body article font2">
        <b>First in the Elm Creek Quilts series: “A heartwarming story of relationships that, like pieces of a quilt, can be connected with discord or with harmony.” —Sandra Dallas, <i>New York Times</i>–bestselling author</b><br/><br/>When Sarah McClure and her husband, Matt, move to Waterford, Pennsylvania, she hopes to make a fresh start in the small college town. Unable to find a job both practical and fulfilling, she takes a temporary position at Elm Creek Manor helping its reclusive owner Sylvia Compson prepare her family estate for sale after the death of her estranged sister. Sylvia is also a master quilter and, as part of Sarah’s compensation, offers to share the secrets of her creative gifts with the younger woman.<br/><br/>During their lessons, the intricate, varied threads of Sylvia’s life begin to emerge. It is the story of a young wife living through the hardships and agonies of the World War II home front; of a family torn apart by jealousy and betrayal; of misunderstanding, loss, and a tragedy that can never be undone. As the bond between them deepens, Sarah resolves to help Sylvia free herself from remembered sorrows and restore her life—and her home—to its former glory. In the process, she confronts painful truths about her own family, even as she creates new dreams for the future.<br/><br/>Just as the darker sections of a quilt can enhance the brighter ones, the mistakes of the past can strengthen understanding and lead the way to new beginnings. A powerful debut by a gifted storyteller, <i>The Quilter’s Apprentice</i> tells a timeless tale of family, friendship, and forgiveness as two women weave the disparate pieces of their lives into a bountiful and harmonious whole.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Chiaverini
      </h2>
      
      <p class="authorDescription body article">Jennifer Chiaverini is the author of the<I> New York Times </I>bestselling Elm Creek Quilts series, five collections of quilt projects, and several historical fiction novels. A graduate of the University of Notre Dame and the University of Chicago, she lives with her husband and sons in Madison, Wisconsin. To learn more, visit JenniferChiaverini.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b53be76